import React, { useState } from 'react'
import styled from 'styled-components'
import { Text } from 'rebass'

import { getBalanceNumber } from '../../../utils/bakery/formatBalance'
import { ButtonPrimary } from '../../../components/Button'
import Value from '../../../components/Value'
import { MINTTOKEN } from '../../../constants/bakery'

// hook
import useEarnings from '../../../hooks/bakery/useEarnings'
import useReward from '../../../hooks/bakery/useReward'

const AmountElement = styled(Text)<{isTen: boolean}>`
  color: ${({theme}) => theme.bsText4};
  & > div > span {
    color: ${({isTen}) => (isTen ? '#303068' : '')};
  }
`
const EarnBtn = styled(ButtonPrimary)<{isTen: boolean}>`
  position: relative;
  flex: 1;
  height: 48px;
  padding: 0 16px;
  background-color: ${({isTen}) => (isTen ? '#DA4550' : '')};
  border: ${({isTen}) => (isTen ? '2px solid #2A3567' : '')};
  &:disabled{
    background-color: ${({isTen}) => (isTen ? '#A3A3A3' : '')};
  }
  &:disabled:hover{
    background-color: ${({isTen}) => (isTen ? '#A3A3A3' : '')};
  }
  &:hover{
    background-color: ${({isTen}) => (isTen ? '#DA4550' : '')};
  }
`
const BtnWrpper = styled.div`
  display: flex;
  align-items: center;
  margin-top: 40px;
`
const IconBtn = styled.img`
  position: absolute;
`

interface HarvestProps {
  name: string
  earnTokenName: string
  lpTokenAddress: string
  otherName: string
  decimal?: number
}

const Harvest:React.FC<HarvestProps> = ({name, earnTokenName, lpTokenAddress, otherName, decimal = undefined}) => {
  const [pendingTx, setPendingTx] = useState(false)
  const earnings = useEarnings(lpTokenAddress, earnTokenName)
  const { onReward } = useReward(lpTokenAddress, earnTokenName)
  
  return (
    <>
      <AmountElement isTen={earnTokenName ===  MINTTOKEN.TEN} fontSize={36} fontWeight={700}>
        {
          [MINTTOKEN.ALICE].includes(earnTokenName) ?
          <Value value={getBalanceNumber(earnings, 6)} />
          : <Value value={getBalanceNumber(earnings, decimal)} />
        }
      </AmountElement>
      {
        earnTokenName ===  MINTTOKEN.TEN
        ? <Text fontSize={14} color={'#2A3567'} fontWeight={600}>{ otherName || earnTokenName } Earned</Text>
        : <Text fontSize={14} fontWeight={600}>{ otherName || earnTokenName } Earned</Text>
      }
        {
          earnTokenName ===  MINTTOKEN.TEN ?
          <BtnWrpper style={{marginTop: 20}}>
            <EarnBtn
              isTen={earnTokenName ===  MINTTOKEN.TEN}
              disabled={!earnings.toNumber() || pendingTx || name === 'Pet Airdrop'}
              onClick={async () => {
                setPendingTx(true)
                await onReward()
                setPendingTx(false)
              }}
            >
              <IconBtn style={{left: '-20px'}} src="/images/bakery/icon_red_btn.svg"></IconBtn>
              <Text fontSize={14} fontWeight={700}>{pendingTx ? 'Collecting ' + (otherName|| earnTokenName) : 'Harvest'}</Text>
              <IconBtn style={{right: '-8px', bottom: '-15px'}} src="/images/bakery/icon_yuanbao.svg"></IconBtn>
            </EarnBtn>
          </BtnWrpper>
          :
          <BtnWrpper>
            <EarnBtn
              isTen={earnTokenName ===  MINTTOKEN.TEN}
              disabled={!earnings.toNumber() || pendingTx || name === 'Pet Airdrop'}
              onClick={async () => {
                setPendingTx(true)
                await onReward()
                setPendingTx(false)
              }}
            >
              <Text fontSize={14} fontWeight={700}>{pendingTx ? 'Collecting ' + (otherName|| earnTokenName) : 'Harvest'}</Text>
            </EarnBtn>
          </BtnWrpper>
        }
    </>
  )
}

export default Harvest